// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9lb4A","content_grid":"styles_content_grid__Sb0ty","content_image":"styles_content_image__f9PFc"};